function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Proper funnel analysis requires the entire story behind each user interaction.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox builds unified passport for each user, containing their entire online and offline interactions with your business. As a result, businesses can make in-depth analysis and informed decisions on various digital sales funnels.")]),_vm._v(" "),_c('p',[_vm._v("With WhiteBox unified profile you can:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Build advanced website functionalities following the user's digital footprint")]),_vm._v(" "),_c('li',[_vm._v("Automatically build advanced auditories on the advertising platforms")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/passport","interaction":"passport","title":"(Unified User)|profiles","image":"/img/interactions/3.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }